// İsim karşılaştırma yardımcıları: firma/ürün kaydederken "aynı" veya
// "benzer" isim uyarısı vermek için kullanılır.

const TURKISH_CHAR_MAP = {
  ı: "i",
  İ: "i",
  I: "i",
  ş: "s",
  Ş: "s",
  ğ: "g",
  Ğ: "g",
  ü: "u",
  Ü: "u",
  ö: "o",
  Ö: "o",
  ç: "c",
  Ç: "c",
};

export const normalizeName = (value) => {
  const str = (value ?? "").toString().trim().replace(/\s+/g, " ");
  const withoutTurkish = str.replace(/[ıİIşŞğĞüÜöÖçÇ]/g, (ch) => TURKISH_CHAR_MAP[ch] || ch);
  return withoutTurkish.toLowerCase();
};

export const levenshtein = (a, b) => {
  if (a === b) return 0;
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  let prevRow = Array.from({ length: b.length + 1 }, (_, i) => i);

  for (let i = 1; i <= a.length; i++) {
    const currRow = [i];
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      currRow[j] = Math.min(
        prevRow[j] + 1, // silme
        currRow[j - 1] + 1, // ekleme
        prevRow[j - 1] + cost // değiştirme
      );
    }
    prevRow = currRow;
  }

  return prevRow[b.length];
};

const SIMILARITY_THRESHOLD = 0.82;

// name: kontrol edilecek yeni isim
// list: mevcut kayıtlar dizisi
// getName: list elemanından ismi çıkaran fonksiyon
// Dönüş: null | { type: "exact" | "similar", match }
export const findSimilarMatch = (name, list = [], getName = (x) => x) => {
  const normalizedNew = normalizeName(name);
  if (!normalizedNew) return null;

  let bestSimilar = null;
  let bestScore = 0;

  for (const item of list) {
    const normalizedExisting = normalizeName(getName(item));
    if (!normalizedExisting) continue;

    if (normalizedExisting === normalizedNew) {
      return { type: "exact", match: item };
    }

    const maxLen = Math.max(normalizedExisting.length, normalizedNew.length);
    const distance = levenshtein(normalizedNew, normalizedExisting);
    const score = maxLen === 0 ? 0 : 1 - distance / maxLen;
    const contains =
      normalizedExisting.length > 2 &&
      normalizedNew.length > 2 &&
      (normalizedExisting.includes(normalizedNew) || normalizedNew.includes(normalizedExisting));

    if ((score >= SIMILARITY_THRESHOLD || contains) && score > bestScore) {
      bestScore = score;
      bestSimilar = item;
    }
  }

  return bestSimilar ? { type: "similar", match: bestSimilar } : null;
};
